import React from 'react';

interface WideHeaderProps {
  title: string;
  introduction?: string;
  introductionHtml?: string;
  caption?: string;
  actions?: React.ReactNode;
  narrow?: boolean;
}

const WideHeader: React.FC<WideHeaderProps> = ({
  title,
  introduction,
  introductionHtml,
  caption,
  actions,
  narrow = false
}) => {
  return (
    <section className="bg-white py-6 border-b border-gray-200">
      <div className={`container mx-auto px-4 ${narrow ? 'max-w-4xl' : ''}`}>
        <div className="flex justify-between items-end">
          <div>
            <h1 className="text-3xl font-cinzel font-bold text-gray-900">{title}</h1>
            {introductionHtml ? (
              <div className="text-gray-600 mt-1" dangerouslySetInnerHTML={{ __html: introductionHtml }} />
            ) : introduction ? (
              <p className="text-gray-600 mt-1">{introduction}</p>
            ) : null}
          </div>
          {actions && (
            <div className="flex space-x-2">
              {actions}
            </div>
          )}
        </div>
        {caption && (
          <div className="mt-4 text-sm text-gray-500">
            {caption}
          </div>
        )}
      </div>
    </section>
  );
};

export default WideHeader;

